import type { ThemePreference } from './auth.ts';

/*
 * The choice as `public/theme-init.js` reads it before the first paint, so a
 * reload does not flash light first. Nothing stored means light.
 */
const STORAGE_KEY = 'wundo-theme';

export function showDark(dark: boolean): void {
  if (dark) document.documentElement.dataset.theme = 'dark';
  else delete document.documentElement.dataset.theme;

  /* The browser chrome (address bar, PWA title bar) follows the canvas. */
  const canvas = getComputedStyle(document.documentElement)
    .getPropertyValue('--color-canvas')
    .trim();
  if (canvas) {
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', canvas);
  }
}

export function rememberTheme(theme: ThemePreference): void {
  try {
    if (theme === 'light') window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* Storage blocked: the theme still applies, it just flashes light on reload. */
  }
}

/** Signing out: the login screen and whoever signs in next start light. */
export function forgetAppTheme(): void {
  rememberTheme('light');
  showDark(false);
}
